import React from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableRow } from '@mui/material';
import { compose } from 'redux';
import { camelize } from 'humps';

export const BrowserItemComponent = ({ item, selectItem, fields, labelFieldName, valueFieldName }) => (
  <TableRow hover>
    {fields.map((field, index) => (
      <TableCell
        style={{ cursor: 'pointer' }}
        align='right'
        onClick={selectItem(item[camelize(labelFieldName)], item[camelize(valueFieldName)])}
        key={index}
      >
        {item[camelize(field.name)]}
      </TableCell>
    ))}
  </TableRow>
);

BrowserItemComponent.propTypes = {
  selectItem: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  fields: PropTypes.array.isRequired,
  labelFieldName: PropTypes.string.isRequired,
  valueFieldName: PropTypes.string.isRequired
};

export default compose()(BrowserItemComponent);
